import styled from 'styled-components'
import { PrimaryButton, SecondaryButton } from '../common/Button'

const HeroSection = styled.section`
  height: 100vh;
  min-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background: linear-gradient(
      135deg,
      rgba(13, 13, 26, 0.9) 0%,
      rgba(26, 26, 46, 0.8) 100%
    ),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 810"><defs><linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style="stop-color:%23667eea;stop-opacity:1" /><stop offset="100%" style="stop-color:%23764ba2;stop-opacity:1" /></linearGradient></defs><rect fill="url(%23grad1)" width="1440" height="810"/><circle fill="%23ff6b6b" opacity="0.1" cx="720" cy="405" r="300"/><circle fill="%234ecdc4" opacity="0.1" cx="200" cy="200" r="200"/><circle fill="%23f9a826" opacity="0.1" cx="1200" cy="600" r="250"/></svg>');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(ellipse at center, transparent 0%, rgba(13, 13, 26, 0.4) 100%);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    min-height: 500px;
    background-attachment: scroll;
  }
`

const HeroContent = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 900px;
  padding: ${({ theme }) => theme.spacing.xl};

  h1 {
    font-size: clamp(3rem, 8vw, 6rem);
    font-weight: 800;
    line-height: 1.1;
    margin-bottom: ${({ theme }) => theme.spacing.lg};
    background: linear-gradient(135deg, #ffffff 0%, #ffd700 50%, #ff6b6b 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-shadow: 0 0 40px rgba(255, 107, 107, 0.3);
    animation: fadeInUp 1s ease-out;

    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(30px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }

  .tagline {
    font-size: clamp(1.125rem, 2.5vw, 1.5rem);
    color: ${({ theme }) => theme.colors.textSecondary};
    margin-bottom: ${({ theme }) => theme.spacing['2xl']};
    line-height: 1.6;
    animation: fadeInUp 1s ease-out 0.2s backwards;
  }

  .description {
    font-size: clamp(1rem, 2vw, 1.125rem);
    color: ${({ theme }) => theme.colors.textMuted};
    margin-bottom: ${({ theme }) => theme.spacing['3xl']};
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    animation: fadeInUp 1s ease-out 0.4s backwards;
  }

  .button-group {
    display: flex;
    gap: ${({ theme }) => theme.spacing.lg};
    justify-content: center;
    flex-wrap: wrap;
    animation: fadeInUp 1s ease-out 0.6s backwards;

    @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
      flex-direction: column;
      align-items: stretch;
    }
  }
`

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.lg};
  background: ${({ theme }) => theme.colors.backgroundLighter};
  border: 1px solid ${({ theme }) => theme.colors.backgroundLighter};
  border-radius: ${({ theme }) => theme.borderRadius.full};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  font-size: ${({ theme }) => theme.fonts.sizes.sm};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text};
  animation: fadeInUp 1s ease-out 0.1s backwards;

  .dot {
    width: 8px;
    height: 8px;
    background: ${({ theme }) => theme.colors.success};
    border-radius: 50%;
    animation: pulse 2s ease-in-out infinite;
  }

  @keyframes pulse {
    0%, 100% {
      opacity: 1;
      transform: scale(1);
    }
    50% {
      opacity: 0.5;
      transform: scale(1.2);
    }
  }
`

const Hero = () => {
  return (
    <HeroSection id="home">
      <HeroContent>
        <Badge>
          <span className="dot"></span>
          Available Now on All Platforms
        </Badge>
        <h1>NEXUS REALMS</h1>
        <p className="tagline">
          Embark on an epic journey across dimensions and discover your destiny
        </p>
        <p className="description">
          Experience the next generation of gaming with stunning visuals, immersive
          storytelling, and endless adventures. Join millions of players in the
          most anticipated RPG of the year.
        </p>
        <div className="button-group">
          <PrimaryButton href="#preorder">Pre-Order Now</PrimaryButton>
          <SecondaryButton href="#trailer">Watch Trailer</SecondaryButton>
        </div>
      </HeroContent>
    </HeroSection>
  )
}

export default Hero
